/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
/* eslint-disable indent */
/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useQuery, useQueryClient } from "react-query";
import { Tooltip } from "react-tippy";
import {
  selectRetrofitConfiguration,
  selectFiltersInit,
  selectPossibleFiltersValues,
  clearBundlesToCompare,
  selectMotorSynchronizedFilters,
  selectSavedMotorDependenciesPayload,
  setSavedMotorDependenciesPayload,
  setMotorSynchronizedFilters,
  showSnackbar,
  saveApplicationDataDependencies,
  selectFiltersWrapperOpened,
  setFiltersWrapperOpened,
  setAxisFilters
} from "../../../../store/slices/retrofit";
import LabelsPicker from "../../../common/Inputs/LabelsPicker/LabelsPicker/LabelsPicker";
import Select from "../../../common/Inputs/Select/Select";
import SelectionRange from "../../../common/Inputs/SelectionRange/SelectionRange";
import ToggleInput from "../../../common/Inputs/ToggleInput/ToggleInput";
import Spinner from "../../../common/Icons/Spinner/Spinner";
import { logEvent, syncFiltersDependencies } from "../../../../utils/common/api/api";
import { formatConnectorType, formatMotorEncoder, formatShaftEnd, formatNbPhases } from "./utils";
import t from "../../../../utils/common/translation/translator";
import { tData } from "../../../../utils/common/translation/dataUtils";
import MsxIcons from "../../../common/Icons/MsxIcons/MsxIcons";
import Button from "../../../common/Buttons/Button/Button";
import { selectConfigurationType, selectEventsData } from "../../../../store/slices/common";
import { selectIntegratedDrivesConfiguration } from "../../../../store/slices/integrated_drives";

const MotorFilters = ({ closeTab, filters, filterToDisplay, gearboxFiltersProp, onApplyFilters, axisId, ...props }) => {
  const possibleMotorFiltersValues = useSelector(selectPossibleFiltersValues)?.motor;
  const retrofitConfiguration = useSelector(selectRetrofitConfiguration);
  const integratedDrivesConfiguration = useSelector(selectIntegratedDrivesConfiguration);
  const configuration = integratedDrivesConfiguration || retrofitConfiguration;
  const [data, setData] = useState(filters?.motorFilter);

  const configurationType = useSelector(selectConfigurationType);

  const [gearboxFilters, setGearboxFilters] = useState(filters?.gearboxFilter);

  const [currentAxis, setCurrentAxis] = useState(null);

  useEffect(() => {
    if (axisId) {
    const axisFromConfiguration = configuration?.configData?.axes?.find((a) => a.id === axisId);

    setCurrentAxis(axisFromConfiguration);
  }
  }, [configuration]);

  useEffect(() => {
    if (gearboxFiltersProp) {
      setGearboxFilters(gearboxFiltersProp);
    }
  }, [gearboxFiltersProp]);

  useEffect(() => {
    setData({
      ...data,
      withGearbox: data?.withGearbox || gearboxFilters?.enabled
    });
  }, []);

  const dispatch = useDispatch();

  const [highlightErrors, setHighlightErrors] = useState(false);

  const handleApplyFilters = () => {
    if (
      !data?.ipDegreeOfProtection ||
      data?.ipDegreeOfProtection?.length === 0 ||
      !data?.holdingBrake ||
      data?.holdingBrake?.length === 0
    ) {
      setHighlightErrors(true);
      dispatch(showSnackbar({ id: "MANDATORY_FIELDS" }));
      return;
    }

    // SHAFT END
    // replace occurence of "Keyed shaft" with the two values "KEYED" and "PARALLEL_KEY"
    // and occurence of "Smooth shaft" with the two values "SMOOTH_SHAFT" and "UNTAPPED"
    const shaftEndFormatted = [];
    data.shaftEnd.map((v) => {
      if (v === "Keyed shaft") {
        shaftEndFormatted.push("KEYED", "PARALLEL_KEY");
      }
      if (v === "Smooth shaft") {
        shaftEndFormatted.push("SMOOTH_SHAFT", "UNTAPPED");
      }
      if (v !== "Keyed shaft" && v !== "Smooth shaft") {
        shaftEndFormatted.push(v);
      }
      return -1;
    });

    // MOTOR ENCODER
    const motorEncoderFormatted = [];
    data.motorEncoder.map((v) => {
      if (v === "SingleTurn") {
        motorEncoderFormatted.push(
          "20_BITS_1_TURN_ABS_ENCODER",
          "SINGLE_TURN_SINCOS_HIPERFACE",
          "ABS_1_TURN_SINCOS_HIPERFACE",
          "ABS_SINGLE_TURN_HIPERFACE_DSL",
          "23_BTS_OPTIC_INCREMENTAL_NCODR"
        );
      }
      if (v === "MultiTurn") {
        motorEncoderFormatted.push(
          "20_BITS_MULTI_TURN_ABS_ENCODER",
          "MULTITURN_SINCOS_HIPERFACE",
          "ABS_MULTITURN_SINCOS_HIPERFACE",
          "ABS_MULTITURN_HIPERFACE_DSL",
          "23_BITS_OPTIC_MULTITURN_ENCDR",
          "17_BITS_MGNTC_MULTITURN_ENCDR"
        );
      }
      if (v !== "SingleTurn" && v !== "MultiTurn") {
        motorEncoderFormatted.push(v);
      }
      return -1;
    });

    // filters of the current axis
    const newFilters = {
      ...configuration.configData.axes.find((a) => a.id === axisId).configFilters,
      motorFilter: {
        ...data
        // shaftEndFormatted,
        // motorEncoderFormatted
      },
      gearboxFilter: {
        ...gearboxFilters,
        enabled: data.withGearbox
      }
      
    };;
    onApplyFilters(axisId, newFilters); 
    dispatch(clearBundlesToCompare());
    closeTab();
  };

  const synchronizedMotorFilters = useSelector(selectMotorSynchronizedFilters);

  const savedDependenciesPayload = useSelector(selectSavedMotorDependenciesPayload);

  // the filter that changed => launched the sync
  // const [filterLaunchingSync, setFilterLaunchingSync] = useState(null);
  const eventsData = useSelector(selectEventsData);

  const storedApplicationDataDependencies = useSelector(
    (state) => state.retrofit?.configuration?.configData?.axes?.find((a) => a.id === axisId)?.axisState?.dependencies
  );

  const applicationDataFiltersValues = useSelector(selectPossibleFiltersValues)?.applicationData;

  const motorPossibleFiltersValues = useSelector(selectPossibleFiltersValues)?.motor;

  const [loading, setLoading] = useState(false);

  const correspondingAttributeName = (attribute) => {
    switch (attribute) {
      case "nominalTorque":
        return "nominalTorqueOfMotor";
      case "nominalSpeed":
        return "nominalSpeedOfMotor";
      case "flangeSize":
        return "flangeSize";
      case "length":
        return "length";
      default:
        return attribute;
    }
  };

  const slidersFilters = ["nominalTorque", "nominalSpeed", "flangeSize", "length"];

  const chipFilters = ["type", "feedbackType", "connectorType", "ipProtection", "holdingBrake", "shaftEnd"];

  // Function to update the loader progress
  const [percentage, setPercentage] = useState(0);
  const updateLoaderProgress = (currentProgress, totalRequests) => {
    const percentageProgress = ((currentProgress / totalRequests) * 100).toFixed(2);
    setPercentage(percentageProgress);
  };

  const isIntegratedDrivesConfiguration = integratedDrivesConfiguration !== null;

  const {
    refetch: execSyncFilters,
    isFetching: isFetchingSyncFilters,
    isLoading: isLoadingSyncFilters
  } = useQuery(
    "SYNC_MOTOR_FILTERS",
    async () => {
      const totalChipFiltersRequests = chipFilters.length;
      const totalSlidersFiltersRequests = slidersFilters.length;
      const totalRequests = totalChipFiltersRequests + totalSlidersFiltersRequests + 3; // (app data + app data of switchable + newFiltersWithSwitchedGearboxToggle)

      let completedRequests = 0;

      const handleRequestCompletion = () => {
        completedRequests += 1;
        updateLoaderProgress(completedRequests, totalRequests);
      };

      const handlePercentageCompletion = () => {
        updateLoaderProgress(totalRequests, totalRequests);
        setTimeout(() => {
          updateLoaderProgress(0, totalRequests);
        }, 100);
      };
      try {
        setLoading(true);
        const motorEncoderFormatted = formatMotorEncoder(data.motorEncoder);
        const shaftEndFormatted = formatShaftEnd(data.shaftEnd);
        const connectorTypeFormatted = formatConnectorType(data.connectorType);
        const nbPhasesFormatted = formatNbPhases(filters?.driveFilter?.nbPhases);
        // console.log("data", data);

        const commonPayload = {
          device: "ALL",
          criteria: {
            locale: window.msizerConfiguration?.locale || "en-WW",
            applicationData: {
              nominalSpeed: parseFloat(filters?.applicationDataFilter?.nominalSpeed),
              nominalTorque: filters?.applicationDataFilter?.nominalTorque
                ? {
                    min: parseFloat(filters?.applicationDataFilter?.nominalTorque),
                    max: applicationDataFiltersValues?.nominalTorque.max
                  }
                : null,
              inertia: parseFloat(filters?.applicationDataFilter?.loadInertia),
              length: parseFloat(filters?.applicationDataFilter?.maxLength),
              withGearbox: data?.withGearbox,
              nominalTorqueOfMotor: data?.nominalTorque, // range
              nominalSpeedOfMotor: data?.nominalSpeed // range
            },
            drive: {
              type: filters?.driveFilter?.driveType || [],
              communicationInterfaces: filters?.driveFilter?.driveInterface || [],
              outputCurrents: filters?.driveFilter?.outputCurrent || [],
              nominalPower: filters?.driveFilter?.nominalPower || [],
              switchingFreq: filters?.driveFilter?.switchingFreq || [],
              format: filters?.driveFilter?.format || [],
              nbPhases: nbPhasesFormatted,
              driveVoltages: filters?.driveFilter?.driveVoltages || []
            },
            motor: {
              type: data?.motorType || [],
              feedbackType: motorEncoderFormatted,
              connectorType: connectorTypeFormatted,
              ipProtection: data?.ipDegreeOfProtection || [],
              holdingBrake: data?.holdingBrake || [],
              shaftEnd: shaftEndFormatted,
              length: data?.length, // range
              flangeSize: data?.flangeSize // range
            },
            gearbox: {
              productOrComponentType: data?.withGearbox ? gearboxFilters?.productOrComponentType || [] : [],
              reductionRatio: data?.withGearbox ? gearboxFilters?.ratio || [] : [],
              torsionalBacklash: data?.withGearbox ? gearboxFilters?.torsionalBacklash : undefined,
              externalDiameter: data?.withGearbox ? gearboxFilters?.externalDiameter || [] : []
            }
          }
        };

        // application Data payload
        let payload = {
          ...commonPayload,
          criteria: {
            ...commonPayload.criteria,
            step: "bundle"
          }
        };

        let newApplicationDataFilters = storedApplicationDataDependencies;

        // eslint-disable-next-line no-unused-vars
        const previousPayload = currentAxis?.axisState?.savedApplicationDataPayload;

        // check if the new payload is different from the previous one (to avoid useless calls)
        if (JSON.stringify(payload) !== JSON.stringify(previousPayload)) {
          // sync application data filters
          newApplicationDataFilters = await syncFiltersDependencies(configurationType, payload);
          newApplicationDataFilters = newApplicationDataFilters?.applicationData;
          dispatch(
            saveApplicationDataDependencies({
              axisId,
              dependencies: newApplicationDataFilters,
              appDataPayload: payload
            })
          );
        }
        handleRequestCompletion();

        // payload used for motor filters
        payload = {
          ...commonPayload,
          criteria: {
            ...commonPayload.criteria,
            step: "motor",
            applicationData: {
              ...commonPayload.criteria.applicationData,
              nominalTorque: filters?.applicationDataFilter?.nominalTorque
                ? {
                    min: parseFloat(filters?.applicationDataFilter?.nominalTorque),
                    max: parseFloat(newApplicationDataFilters?.nominalTorque?.min * 1.3)
                  }
                : null
            }
          }
        };

        if (savedDependenciesPayload && JSON.stringify(payload) === JSON.stringify(savedDependenciesPayload)) {
          setLoading(false);
          handlePercentageCompletion();
          return synchronizedMotorFilters;
        }

        // sync motor filters
        const newFiltersPromise = syncFiltersDependencies(configurationType, payload);
        // console.log("newFilters", newFilters);

        // for each slider, send a request without the min and max of the slider
        const slidersPayloads = {};
        ["nominalTorque", "nominalSpeed", "flangeSize", "length"].forEach(async (attribute) => {
          // create a payload using the synchronized filters min and max (example : syncronizedFilters?.nominalTorque?.min)
          // if the attribute is nominalTorque or nominalSpeed we put it in applicationData
          // else we put it in motor
          const payloadWithoutSlider = {
            ...payload,
            sliderName: attribute,
            criteria: {
              ...payload.criteria,
              applicationData: {
                ...payload.criteria.applicationData,
                ...(attribute === "nominalTorque" || attribute === "nominalSpeed"
                  ? {
                      [correspondingAttributeName(attribute)]: {
                        min: motorPossibleFiltersValues?.[attribute]?.min,
                        max: motorPossibleFiltersValues?.[attribute]?.max
                      }
                    }
                  : {})
              },
              motor: {
                ...payload.criteria.motor,
                ...(attribute !== "nominalTorque" && attribute !== "nominalSpeed"
                  ? {
                      [correspondingAttributeName(attribute)]: {
                        min: motorPossibleFiltersValues?.[attribute]?.min,
                        max: motorPossibleFiltersValues?.[attribute]?.max
                      }
                    }
                  : {})
              }
            }
          };

          // save the slidersPayloads in the state in order to do multiple async calls at the same time
          slidersPayloads[attribute] = payloadWithoutSlider;
        });

        // console.log("slidersPayloads", slidersPayloads);

        // sync filters foreach slider (do multiple async calls at the same time)
        // slidersPayloadsResults is an object of the results of the async calls with a key for each slider
        const slidersPayloadsResultsPromise = Promise.all(
          Object.keys(slidersPayloads).map(async (key) => {
            const result = await syncFiltersDependencies(configurationType, slidersPayloads[key]);
            handleRequestCompletion();
            return { [key]: result };
          })
        ).then((results) => {
          const res = {};
          results.forEach((result) => {
            const key = Object.keys(result)[0];
            res[key] = result[key]?.motor?.[key];
          });
          return res;
        });
        // console.log("slidersPayloadsResults", slidersPayloadsResults);

        // for each chip filter, send a request without the chip filter
        const chipFiltersPayloads = {};
        chipFilters.forEach(async (attribute) => {
          const payloadWithoutChipFilter = {
            ...payload,
            chipFilterName: attribute,
            criteria: {
              ...payload.criteria,
              motor: {
                ...payload.criteria.motor,
                [attribute]: []
              }
            }
          };

          // save the chipFiltersPayloads in the state in order to do multiple async calls at the same time
          chipFiltersPayloads[attribute] = payloadWithoutChipFilter;
        });

        const chipFiltersPayloadsResultsPromise = Promise.all(
          Object.keys(chipFiltersPayloads).map(async (key) => {
            const result = await syncFiltersDependencies(configurationType, chipFiltersPayloads[key]);
            handleRequestCompletion();
            return { [key]: result };
          })
        ).then((results) => {
          const res = {};
          results.forEach((result) => {
            const key = Object.keys(result)[0];
            res[key] = result[key]?.motor?.[key];
          });
          return res;
        });

        const [newFilters, slidersPayloadsResults, chipFiltersPayloadsResults] = await Promise.all([
          newFiltersPromise,
          slidersPayloadsResultsPromise,
          chipFiltersPayloadsResultsPromise
        ]);

        // console.log("chipFiltersPayloadsResults", chipFiltersPayloadsResults);

        // payloadWithSwitchedGearboxToggle is the same payload but we change the withGearbox criteria of appData to false if it was true and vice versa
        const payloadWithSwitchedGearboxToggle = {
          ...payload,
          criteria: {
            ...payload.criteria,
            applicationData: {
              ...payload.criteria.applicationData,
              withGearbox: !payload.criteria.applicationData.withGearbox
            },
            gearbox: {
              // if payload.criteria.applicationData.withGearbox then gearbox object is empty
              ...(!payload.criteria.applicationData.withGearbox ? payload.criteria.gearbox : {})
            }
          }
        };
        const newAppDataFiltersWithSwitchedGearboxToggle = await syncFiltersDependencies(configurationType, {
          ...payloadWithSwitchedGearboxToggle,
          criteria: {
            ...payloadWithSwitchedGearboxToggle.criteria,
            step: "bundle",
            applicationData: {
              ...payloadWithSwitchedGearboxToggle.criteria.applicationData,
              nominalTorque: filters?.applicationDataFilter?.nominalTorque
                ? {
                    min: parseFloat(filters?.applicationDataFilter?.nominalTorque),
                    max: applicationDataFiltersValues?.nominalTorque.max
                  }
                : null
            }
          }
        });
        handleRequestCompletion();

        const newFiltersWithSwitchedGearboxToggle = await syncFiltersDependencies(configurationType, {
          ...payloadWithSwitchedGearboxToggle,
          criteria: {
            ...payloadWithSwitchedGearboxToggle.criteria,
            applicationData: {
              ...payloadWithSwitchedGearboxToggle.criteria.applicationData,
              nominalTorque: filters?.applicationDataFilter?.nominalTorque
                ? {
                    min: parseFloat(filters?.applicationDataFilter?.nominalTorque),
                    max: parseFloat(
                      newAppDataFiltersWithSwitchedGearboxToggle?.applicationData?.nominalTorque?.min * 3.0
                    )
                  }
                : null
            }
          }
        });
        handleRequestCompletion();
        const gearboxToggleSwitchable = newFiltersWithSwitchedGearboxToggle?.motor?.countOfBundles > 0;

        const newSynchronizedFilters = {
          // ...newFilters.motor, and add gearboxToggleSwitchable to it
          ...newFilters.motor,
          ...chipFiltersPayloadsResults,
          slidersPayloadsResults: {
            ...slidersPayloadsResults
          },
          // ...filterLaunchingSync,
          gearboxToggleSwitchable
        };
        dispatch(setMotorSynchronizedFilters(JSON.parse(JSON.stringify(newSynchronizedFilters))));
        dispatch(setSavedMotorDependenciesPayload(payload));
        setLoading(false);
        handlePercentageCompletion();
        return newFilters;
      } catch (error) {
        console.log("error", error);
        dispatch(showSnackbar({ id: "ERROR_FILTERS" }));
        logEvent(eventsData.locale, eventsData.types.errorFilters, eventsData.tags.none, configuration?.configId);
        setLoading(false);
        handlePercentageCompletion();
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const getDisabledLabels = (feedbackTypes) => {
    // console.log("getDisabledFIlters, feedbackTypes =>", feedbackTypes);
    const disabledLabels = [];

    if (
      !feedbackTypes.some((r) =>
        [
          "20_BITS_1_TURN_ABS_ENCODER",
          "SINGLE_TURN_SINCOS_HIPERFACE",
          "ABS_1_TURN_SINCOS_HIPERFACE",
          "ABS_SINGLE_TURN_HIPERFACE_DSL",
          "23_BTS_OPTIC_INCREMENTAL_NCODR"
        ].includes(r)
      )
    ) {
      disabledLabels.push("single_turn");
    }

    if (
      !feedbackTypes.some((r) =>
        [
          "20_BITS_MULTI_TURN_ABS_ENCODER",
          "MULTITURN_SINCOS_HIPERFACE",
          "ABS_MULTITURN_SINCOS_HIPERFACE",
          "ABS_MULTITURN_HIPERFACE_DSL",
          "23_BITS_OPTIC_MULTITURN_ENCDR",
          "17_BITS_MGNTC_MULTITURN_ENCDR"
        ].includes(r)
      )
    ) {
      disabledLabels.push("multi_turn");
    }

    // console.log("disabledLabels =>", disabledLabels);
    return disabledLabels;
  };

  const getDisabledShaftEnd = (shaftEnd) => {
    const disabledLabels = [];

    if (!shaftEnd.some((r) => ["KEYED", "PARALLEL_KEY"].includes(r))) {
      disabledLabels.push("keyed");
    }

    if (!shaftEnd.some((r) => ["SMOOTH_SHAFT", "UNTAPPED"].includes(r))) {
      disabledLabels.push("smooth_shaft");
    }
    return disabledLabels;
  };

  const getDisabledConnectorType = (connectorType) => {
    const disabledLabels = [];

    if (!connectorType.some((r) => ["STRAIGHT_CONNECTOR", "STRAIGHT_CONNECTORS"].includes(r))) {
      disabledLabels.push("Straight");
    }

    if (!connectorType.some((r) => ["ROTATABLE_RIGHT-ANGLED_CONNS", "ROTATABLE_RH_ANGLED_CONNECTOR"].includes(r))) {
      disabledLabels.push("Angled");
    }

    if (!connectorType.some((r) => ["CABLE_WITH_STRIPPED_END"].includes(r))) {
      disabledLabels.push("Free Lead");
    }

    if (!connectorType.some((r) => ["MIL"].includes(r))) {
      disabledLabels.push("MIL");
    }

    if (!connectorType.some((r) => ["MALE_FEMALE"].includes(r))) {
      disabledLabels.push("male/female");
    }

    return disabledLabels;
  };

  const queryClient = useQueryClient();
  // const launchSyncAppData = useSelector(selectLaunchSyncAppData);

  const [firstOccurence, setFirstOccurence] = useState(true);

  useEffect(() => {
    if (data && !firstOccurence && !isIntegratedDrivesConfiguration) {
      // console.log("syncronize motor filters, data =>", data);
      // dispatch(setLaunchSyncAppData(!launchSyncAppData));
      queryClient.cancelQueries("SYNC_DRIVE_FILTERS");
      queryClient.cancelQueries("SYNC_GEARBOX_FILTERS");
      // wait until isSynchronizingAppDataFilters is false to run execSyncFilters
      if(!isIntegratedDrivesConfiguration) { 
        execSyncFilters();

        const newFilters = {
          ...configuration.configData.axes.find((a) => a.id === axisId)?.configFilters,
          motorFilter: {
            ...data
          },
          gearboxFilter: {
            ...gearboxFilters,
            enabled: data.withGearbox
          } 
        };
       
        dispatch(setAxisFilters({ axisId, filters: newFilters }));

        // dispatch(setLaunchSyncAppData(!launchSyncAppData));
        // dispatch(clearBundlesToCompare());
      }
    } else {
      setFirstOccurence(false);
    }
  }, [data, gearboxFilters]);

  const filtersInit = useSelector(selectFiltersInit);
  const handleClearFilters = () => {
    setData({
      ...filtersInit.motorFilter,

      motorType: [],
      motorEncoder: [],
      connectorType: [],
      ipDegreeOfProtection: [],
      holdingBrake: [],
      shaftEnd: []
    });
    // setData(filtersInit.motorFilter);
  };
  const groupMotorTypeValues = (values) => {
    // group SH3..P and SH3..M to SH3
    // don't group other values

    // console.log("group motor type values =>", values);

    const groupedValues = [];

    values.forEach((value) => {
      switch (value) {
        case "SH3..P":
        case "SH3..M":
          groupedValues.push("SH3");
          break;

        default:
          groupedValues.push(value);
      }
    });

    // console.log("grouped motor type values =>", [...new Set(groupedValues)]);

    // return unique values of the array
    return [...new Set(groupedValues)];
  };

  const filtersWrapperOpened = useSelector(selectFiltersWrapperOpened);

  const gearboxToggle = (
    <div
      className={`flex justify-start items-center space-x-2 space-y-1
      ${
        (loading || isFetchingSyncFilters || isLoadingSyncFilters || !data || !synchronizedMotorFilters) && !isIntegratedDrivesConfiguration
          ? "opacity-50 pointer-events-none"
          : ""
      }
      `}
      {...props}
    >
      {!synchronizedMotorFilters?.gearboxToggleSwitchable && !isIntegratedDrivesConfiguration && (
        <div>
          <Tooltip
            title={t("msizer.ui.tooltip.cannot_change_option")}
            position="right"
            duration={200}
            arrow
            size="small"
            theme="light"
          >
            <span className="cursor-pointer">
              <MsxIcons
                name="info-tooltip"
                size="nano"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              />
            </span>
          </Tooltip>
        </div>
      )}
      {synchronizedMotorFilters?.gearboxToggleSwitchable && <div />}
      <ToggleInput
        idLabel="motor-with-gearbox"
        switchable={(synchronizedMotorFilters && synchronizedMotorFilters?.gearboxToggleSwitchable) || isIntegratedDrivesConfiguration}
        checked={filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled}
        loading={loading || isFetchingSyncFilters || isLoadingSyncFilters}
        minimal={filterToDisplay === "gearboxToggleMinimal"}
        onChange={(checked) => {
          setData({ ...data, withGearbox: checked });
          const newFilters = {
            ...filters,
            gearboxFilter: {
              ...gearboxFilters,
              enabled: checked
            },
            motorFilter: {
              ...filters.motorFilter,
              withGearbox: checked
            }
          };
          onApplyFilters(axisId, newFilters);
          // handleToggleInputChange(checked);
          setTimeout(() => {
            if (checked && filtersWrapperOpened !== "GEARBOX") {
              dispatch(setFiltersWrapperOpened("GEARBOX"));
            }
            if (!checked && filtersWrapperOpened === "GEARBOX") {
              dispatch(setFiltersWrapperOpened(null));
            }
          }, 10);
        }}
        label={t("msizer.ui.motor_filters.motor_with_gearbox")}
      />
    </div>
  );

  if (filterToDisplay === "gearboxToggle" || filterToDisplay === "gearboxToggleMinimal") {
    return gearboxToggle;
  }

  return (
    <>
      <div data-testid="motor-filters" className="relative">
        <div
          // use the percentage for the width
          className="h-1 rounded bg-primary transition-all duration-100"
          style={{
            width: `${percentage}%`
          }}
        />
        <div
          className={`bg-gray-50 backdrop-blur-xs bg-opacity-50 h-full w-full top-0 left-0 absolute flex items-center justify-center z-20 ${
            !(isFetchingSyncFilters || isLoadingSyncFilters || !data) && "hidden"
          }`}
        >
          <Spinner />
        </div>
        <div className="md:flex justify-end hidden">
          <span
            onClick={handleClearFilters}
            className="text-secondary text-sm px-2 py-1 cursor-pointer hover:underline select-none"
          >
            {t("msizer.ui.filters.clear")}
          </span>
        </div>
        <div className="md:flex space-x-2 divide-x-2 divide-gray-100 divide-solid">
          <div className="flex-1 p-2 space-y-4">
            <SelectionRange
              label={t("msizer.ui.motor_filters.nominal_torque_of_motor")}
              min={synchronizedMotorFilters?.slidersPayloadsResults?.nominalTorque?.min}
              max={synchronizedMotorFilters?.slidersPayloadsResults?.nominalTorque?.max}
              possibleMin={synchronizedMotorFilters?.nominalTorque?.min}
              possibleMax={synchronizedMotorFilters?.nominalTorque?.max}
              unit={t("msizer.ui.unit.nm")}
              step={0.05}
              currentMin={data?.nominalTorque?.min}
              currentMax={data?.nominalTorque?.max}
              onChange={(min, max) => {
                // setFilterLaunchingSync({
                //   nominalTorque: {
                //     min: synchronizedMotorFilters?.nominalTorque?.min,
                //     max: synchronizedMotorFilters?.nominalTorque?.max
                //   }
                // });
                // console.log("Nominal torque", min, max);
                setData({ ...data, nominalTorque: { min, max } });
              }}
              changeWithInit
            />

            <SelectionRange
              label={t("msizer.ui.motor_filters.nominal_speed_of_motor")}
              min={synchronizedMotorFilters?.slidersPayloadsResults?.nominalSpeed?.min}
              max={synchronizedMotorFilters?.slidersPayloadsResults?.nominalSpeed?.max}
              possibleMin={synchronizedMotorFilters?.nominalSpeed?.min}
              possibleMax={synchronizedMotorFilters?.nominalSpeed?.max}
              unit={t("msizer.ui.unit.rpm")}
              currentMin={data?.nominalSpeed?.min}
              currentMax={data?.nominalSpeed?.max}
              onChange={(min, max) => {
                // setFilterLaunchingSync({
                //   nominalSpeed: {
                //     min: synchronizedMotorFilters?.nominalSpeed?.min,
                //     max: synchronizedMotorFilters?.nominalSpeed?.max
                //   }
                // });
                // console.log(min, max);
                setData({ ...data, nominalSpeed: { min, max } });
              }}
              changeWithInit
            />

            <SelectionRange
              label={t("msizer.ui.motor_filters.flange_size")}
              min={synchronizedMotorFilters?.slidersPayloadsResults?.flangeSize?.min}
              max={synchronizedMotorFilters?.slidersPayloadsResults?.flangeSize?.max}
              possibleMin={synchronizedMotorFilters?.flangeSize?.min}
              possibleMax={synchronizedMotorFilters?.flangeSize?.max}
              unit={t("msizer.ui.unit.mm")}
              currentMin={data?.flangeSize?.min}
              currentMax={data?.flangeSize?.max}
              onChange={(min, max) => {
                // setFilterLaunchingSync({
                //   flangeSize: {
                //     min: synchronizedMotorFilters?.flangeSize?.min,
                //     max: synchronizedMotorFilters?.flangeSize?.max
                //   }
                // });
                console.log(min, max);
                setData({ ...data, flangeSize: { min, max } });
              }}
              changeWithInit
            />
          </div>
          <div className="flex-1 p-2 space-y-4">
            <LabelsPicker
              idLabel="ip-degree"
              label={t("msizer.ui.motor_filters.ip_degree_of_protection")}
              singleChoice
              required
              error={highlightErrors && (!data?.ipDegreeOfProtection || data?.ipDegreeOfProtection?.length === 0)}
              cols={3}
              options={[
                // loop over all possible IP degrees except null values
                ...possibleMotorFiltersValues?.ipDegreeOfProtection
                  .filter((d) => d !== null)
                  ?.sort()
                  .map((degree) => ({
                    label: tData("motor", "ip_degree_of_protection", degree),
                    key: degree
                  }))
              ]}
              selectedLabelsInit={data?.ipDegreeOfProtection}
              onChange={(val) => {
                // setFilterLaunchingSync({
                //   ipProtection: synchronizedMotorFilters?.ipProtection
                // });
                // console.log(val);
                setData({ ...data, ipDegreeOfProtection: val });
              }}
              disabledLabels={possibleMotorFiltersValues?.ipDegreeOfProtection.filter(
                (val) => !synchronizedMotorFilters?.ipProtection?.includes(val) || !synchronizedMotorFilters
              )}
              changeWithInit
            />

            {/*
            <Select
              id="MotorType"
              label={t("msizer.ui.motor_filters.motor_type")}
              initValue={data?.motorType}
              onSelect={(type) => {
                // setFilterLaunchingSync({
                //   type: synchronizedMotorFilters?.type
                // });
                // console.log(type);
                setData({ ...data, motorType: type || undefined });
              }}
              options={[
                {
                  label: t("msizer.ui.motor_filters.motor_type.placeholder"),
                  key: ""
                },
                ...groupMotorTypeValues(
                  synchronizedMotorFilters?.type || []
                ).map((type) => ({
                  label: tData("motor", "motor_type", type),
                  key: type
                }))
              ]}
              changeWithInit
            />

            <SelectionRange
              label={t("msizer.ui.motor_filters.motor_length")}
              min={synchronizedMotorFilters?.slidersPayloadsResults?.length?.min}
              max={synchronizedMotorFilters?.slidersPayloadsResults?.length?.max}
              possibleMin={synchronizedMotorFilters?.length?.min}
              possibleMax={synchronizedMotorFilters?.length?.max}
              step={0.1}
              unit={t("msizer.ui.unit.mm")}
              currentMin={data?.length?.min}
              currentMax={data?.length?.max}
              onChange={(min, max) => {
                // setFilterLaunchingSync({
                //   length: {
                //     min: synchronizedMotorFilters?.length?.min,
                //     max: synchronizedMotorFilters?.length?.max
                //   }
                // });
                // console.log(min, max);
                setData({ ...data, length: { min, max } });
            */}
            <LabelsPicker
              idLabel="motor-type"
              label={t("msizer.ui.motor_filters.motor_type")}
              singleChoice
              error={highlightErrors && (!data?.motorType || data?.motorType?.length === 0)}
              cols={3}
              options={[
                ...groupMotorTypeValues(possibleMotorFiltersValues?.motorType || [])
                  .filter((d) => d !== null)
                  ?.sort()
                  .map((type) => ({
                    label: tData("motor", "motor_type", type),
                    key: type
                  }))
              ]}
              selectedLabelsInit={data?.motorType}
              onChange={(val) => {
                // setFilterLaunchingSync({
                //   ipProtection: synchronizedMotorFilters?.ipProtection
                // });
                // console.log(val);
                setData({ ...data, motorType: val });
              }}
              disabledLabels={[...groupMotorTypeValues(possibleMotorFiltersValues?.motorType || [])].filter(
                (val) =>
                  ![...groupMotorTypeValues(synchronizedMotorFilters?.type || [])].includes(val) ||
                  !synchronizedMotorFilters
              )}
              changeWithInit
            />

            {/* <SelectionRange
              label={t("msizer.ui.motor_filters.peak_stall_torque")}
              min={possibleMotorFiltersValues.peakStallTorque.min}
              max={possibleMotorFiltersValues.peakStallTorque.max}
              step={0.1}
              unit={t("msizer.ui.unit.nm")}
              minValueInit={data.peakStallTorque?.min}
              maxValueInit={data.peakStallTorque?.max}
              onChange={(min, max) => {
                console.log(min, max);
                setData({ ...data, peakStallTorque: { min, max } });
              }}
              changeWithInit
            /> */}
            <SelectionRange
              idLabel="motor-length"
              label={t("msizer.ui.motor_filters.motor_length")}
              min={synchronizedMotorFilters?.slidersPayloadsResults?.length?.min}
              max={synchronizedMotorFilters?.slidersPayloadsResults?.length?.max}
              possibleMin={synchronizedMotorFilters?.length?.min}
              possibleMax={synchronizedMotorFilters?.length?.max}
              step={0.1}
              unit={t("msizer.ui.unit.mm")}
              minValueInit={data?.motorLength?.min}
              maxValueInit={data?.motorLength?.max}
              onChange={(min, max) => {
                // setFilterLaunchingSync({
                //   length: {
                //     min: synchronizedMotorFilters?.length?.min,
                //     max: synchronizedMotorFilters?.length?.max
                //   }
                // });
                console.log(min, max);
                setData({ ...data, motorLength: { min, max } });
              }}
              changeWithInit
            />
          </div>
          <div className="flex-1 p-2 space-y-4">
            <LabelsPicker
              idLabel="motor-holding-brake"
              label={t("msizer.ui.motor_filters.holding_brake")}
              singleChoice
              required
              error={highlightErrors && (!data?.holdingBrake || data?.holdingBrake?.length === 0)}
              cols={2}
              options={[
                // eslint-disable-next-line max-len
                // loop over all possible holding brakes except null values, and if value is 0 return "Without", and if value is 1 return "With", else return the value
                ...possibleMotorFiltersValues?.holdingBrake
                  .filter((element) => element !== null)
                  .map((hb) => ({
                    // eslint-disable-next-line no-nested-ternary
                    label: tData("motor", "holding_brake", hb === false ? "no" : hb === true ? "yes" : hb),
                    key: hb
                  }))
              ]}
              disabledLabels={possibleMotorFiltersValues?.holdingBrake.filter(
                (val) => !synchronizedMotorFilters?.holdingBrake?.includes(val) || !synchronizedMotorFilters
              )}
              selectedLabelsInit={data?.holdingBrake}
              onChange={(val) => {
                // setFilterLaunchingSync({
                //   holdingBrake: synchronizedMotorFilters?.holdingBrake
                // });
                // console.log(val);
                setData({ ...data, holdingBrake: val });
              }}
              changeWithInit
            />

            <LabelsPicker
              idLabel="motor-shaft-end"
              label={t("msizer.ui.motor_filters.shaft_end")}
              singleChoice
              recommended
              cols={2}
              options={[
                // loop over all possible shaft ends except null values
                ...possibleMotorFiltersValues?.shaftEnd
                  .filter((se) => ![null, "SMOOTH_SHAFT", "KEYED", "UNTAPPED", "PARALLEL_KEY"].includes(se))
                  .concat(["keyed", "smooth_shaft"])
                  .map((se) => ({
                    label: tData("motor", "shaft_end", se),
                    key: se
                  }))
              ]}
              selectedLabelsInit={data?.shaftEnd}
              disabledLabels={getDisabledShaftEnd(synchronizedMotorFilters?.shaftEnd || [])}
              onChange={(val) => {
                // setFilterLaunchingSync({
                //   shaftEnd: synchronizedMotorFilters?.shaftEnd
                // });
                setData({ ...data, shaftEnd: val });
              }}
              changeWithInit
            />

            <LabelsPicker
              idLabel="motor-feedback"
              label={t("msizer.ui.motor_filters.feedback_type")}
              singleChoice
              cols={2}
              options={[
                // loop through all the possible values except null values
                ...possibleMotorFiltersValues?.motorEncoder
                  .filter(
                    (se) =>
                      ![
                        null,
                        "20_BITS_1_TURN_ABS_ENCODER",
                        "20_BITS_MULTI_TURN_ABS_ENCODER",
                        "SINGLE_TURN_SINCOS_HIPERFACE",
                        "MULTITURN_SINCOS_HIPERFACE",
                        "ABS_MULTITURN_SINCOS_HIPERFACE",
                        "ABS_1_TURN_SINCOS_HIPERFACE",
                        "ABS_SINGLE_TURN_HIPERFACE_DSL",
                        "ABS_MULTITURN_HIPERFACE_DSL",
                        "23_BTS_OPTIC_INCREMENTAL_NCODR",
                        "23_BITS_OPTIC_MULTITURN_ENCDR",
                        "17_BITS_MGNTC_MULTITURN_ENCDR"
                      ].includes(se)
                  )
                  .concat(["single_turn", "multi_turn"])
                  .map((value) => ({
                    label: tData("motor", "feedback_type", value),
                    key: value
                  }))
              ]}
              selectedLabelsInit={data?.motorEncoder}
              onChange={(val) => {
                // setFilterLaunchingSync({
                //   feedbackType: synchronizedMotorFilters?.feedbackType
                // });
                // console.log(val);
                setData({ ...data, motorEncoder: val });
              }}
              disabledLabels={getDisabledLabels(synchronizedMotorFilters?.feedbackType || [])}
              changeWithInit
            />

            <LabelsPicker
              idLabel="motor-connector"
              label={t("msizer.ui.motor_filters.connector_type")}
              singleChoice
              recommended
              cols={2}
              options={[
                // loop through all the possible values except null values
                ...possibleMotorFiltersValues?.connectorType
                  .filter(
                    (se) =>
                      ![
                        null,
                        "STRAIGHT_CONNECTOR",
                        "STRAIGHT_CONNECTORS",
                        "ROTATABLE_RIGHT-ANGLED_CONNS",
                        "ROTATABLE_RH_ANGLED_CONNECTOR",
                        "CABLE_WITH_STRIPPED_END"
                      ].includes(se)
                  )
                  .concat(["Straight", "Angled", "Free Lead"])
                  ?.sort()
                  .map((value) => ({
                    label: tData("motor", "connector_type", value),
                    key: value
                  }))
              ]}
              selectedLabelsInit={data?.connectorType}
              onChange={(val) => {
                // setFilterLaunchingSync({
                //   connectorType: synchronizedMotorFilters?.connectorType
                // });
                setData({ ...data, connectorType: val });
              }}
              disabledLabels={getDisabledConnectorType(synchronizedMotorFilters?.connectorType || [])}
              changeWithInit
            />
            {/* <SelectionRange
              label={t("msizer.ui.motor_filters.continuous_stall_torque")}
              min={possibleMotorFiltersValues.continuousStallTorque.min}
              max={possibleMotorFiltersValues.continuousStallTorque.max}
              step={0.1}
              unit={t("msizer.ui.unit.nm")}
              minValueInit={data.continuousStallTorque?.min}
              maxValueInit={data.continuousStallTorque?.max}
              onChange={(min, max) => {
                console.log(min, max);
                setData({ ...data, continuousStallTorque: { min, max } });
              }}
              changeWithInit
            /> */}
          </div>
        </div>
      </div>
      <div className="flex justify-center space-x-2 pt-2">
        <div className="flex-1 px-2" />
        {/* <div className="flex-1 px-2 flex items-center space-x-2 text-gray-500 text-sm">
            <span>Bundles found</span>
            {isFetchingSyncFilters || isLoadingSyncFilters ? (
              <span>
                <Spinner small gray />
              </span>
            ) : (
              <span className="font-semibold">
                : {synchronizedMotorFilters?.countOfBundles}
              </span>
            )}
          </div> */}
        <div className="flex-1 px-2 flex gap-2 md:gap-0 justify-center">
          <qds-button
            id="select-filters-button-apply"
            disabled={
              !data?.ipDegreeOfProtection ||
              data?.ipDegreeOfProtection?.length === 0 ||
              !data?.holdingBrake ||
              data?.holdingBrake?.length === 0
            }
            onClick={handleApplyFilters}
            text={t("msizer.ui.popup.button.apply")}
          >
          </qds-button>
          <Button onClick={handleClearFilters} border="blue" textColor="blue" large classes="md:hidden">
            {t("msizer.ui.filters.clear")}
          </Button>
        </div>
        <div className="flex-1 px-2" />
      </div>
    </>
  );
};

MotorFilters.propTypes = {
  closeTab: PropTypes.func,
  filterToDisplay: PropTypes.string,
  gearboxFiltersProp: PropTypes.objectOf(PropTypes.any)
};

MotorFilters.defaultProps = {
  closeTab: () => {},
  filterToDisplay: null,
  gearboxFiltersProp: undefined
};

export default MotorFilters;
